import cx from 'classnames';
import React, { LiHTMLAttributes } from 'react';
import { ICONS } from '../../constants/icons';
import { TextVariant } from '../Text/Text';
import textStyles from '../Text/Text.module.scss';
import styles from './List.module.scss';

export interface ListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  icon?: ICONS;
  isIconTop?: boolean;
  text?: TextVariant;
}

export const ListItem = ({
  className,
  icon,
  isIconTop,
  text,
  children,
  style,
  ...props
}: ListItemProps) => {
  const background = icon ? `url(${icon}) no-repeat left top` : undefined;
  return (
    <li
      className={cx(text && textStyles[text], className)}
      style={{ background, ...style }}
      {...props}
    >
      {background ? (
        <div
          className={cx(background && styles.withIcon, isIconTop && styles.isIconTop)}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </li>
  );
};
